import { AppModule } from 'app/module';
import { ProposalItem } from 'module/proposalItem/main';
import Template from './template.hbs';
import './styles.scss';

export class ProposalList extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            proposalItems: ['.m-proposalItem'],
        };
    }

    subs() {
        this.proposalItems = [];
        for (let i = 0; i < this.dom.proposalItems.length; i += 1) {
            this.proposalItems[i] = new ProposalItem(this.dom.proposalItems[i]);
        }
    }

    subEvents() {
        for (let i = 0; i < this.proposalItems.length; i += 1) {
            this.propagateEvents(this.proposalItems[i], 'proposalLinkClicked');
        }
    }
}
